
export default function TestimonialCard({ creator, colors }) {
    const { avatar_url, name, type, testimonial } = creator;
  
    return (
      <div className="max-w-[452px] w-full px-5 py-4 flex flex-col gap-5 md:gap-6 md:px-4 md:py-6 rounded-lg overflow-hidden" style={{
        background: colors.background,
        border: `1px solid ${colors.border}`
      }}>
        <p className="text-sm md:text-xl text-[#16191B]">{testimonial}</p>
        <div className="mt-auto flex flex-row items-center">
          <img
            src={avatar_url}
            alt={name}
            className="h-[2.625rem] w-[2.625rem] md:h-14 md:w-14 rounded-full overflow-hidden object-cover mr-3 md:mr-4"
          />
          <div className="flex flex-col">
            <h1 className="text-sm md:text-base text-[#16191B] font-bold md:font-semibold leading-normal">
              {name}
            </h1>
            <h2 className="mt-1 italic text-xs md:text-sm text-[#16191B] leading-normal">
              {type}
            </h2>
          </div>
        </div>
      </div>
    );
  }